<template>
    <div class="min-h-16 w-full flex flex-col shrink-0 rounded-b-[inherit]">
        <slot></slot>
    </div>
</template>
